<template>
  <v-container fluid>
    <v-row>
      <v-col sm="12">
        <div v-if="isOchinUser">
          <v-card class="elevation-0">
            <v-tabs background-color="transparent" vertical slider-size="3">
              <v-tabs-slider></v-tabs-slider>

              <v-tab
                data-cy="activePacksTab_ReleaseCycle"
                class="mx-0 mr-8 pr-8 widgetActivePackList__tabs"
                color="grey"
                link
              >
                Release Cycle
              </v-tab>
              <v-tab
                data-cy="activePacksTab_CriticalFix"
                class="mx-0 mr-8 pr-8 widgetActivePackList__tabs"
                color="grey"
                link
              >
                Critical Fix
              </v-tab>
              <v-tab
                data-cy="activePacksTab_Project"
                class="mx-0 mr-8 pr-8 widgetActivePackList__tabs"
                color="grey"
                link
              >
                Project/Standalone
              </v-tab>
              <v-tab-item>
                <active-packs-at-a-glance
                  ref="releaseCyclePacks"
                  :ochinView="isOchinUser"
                  :packDataIsLoading="packDataIsLoading"
                  :packList="releaseCyclePacks"
                  data-cy="widgetOchinView"
                ></active-packs-at-a-glance>
              </v-tab-item>
              <v-tab-item>
                <active-packs-at-a-glance
                  ref="criticalFixPacks"
                  :ochinView="isOchinUser"
                  :packDataIsLoading="packDataIsLoading"
                  :packList="criticalFixPacks"
                ></active-packs-at-a-glance>
              </v-tab-item>
              <v-tab-item>
                <active-packs-at-a-glance
                  ref="projectStandalonePacks"
                  :ochinView="isOchinUser"
                  :packDataIsLoading="packDataIsLoading"
                  :packList="projectStandalonePacks"
                ></active-packs-at-a-glance>
              </v-tab-item>
            </v-tabs>
          </v-card>
        </div>
        <div v-else>
          <h2 class="font-weight-thin">Active Packs at a Glance</h2>
          <active-packs-at-a-glance
            ref="activePacksAtAGlance"
            :ochinView="isOchinUser"
            :packDataIsLoading="packDataIsLoading"
            :packList="filteredActivePackList"
            data-cy="widgetMemberView"
          ></active-packs-at-a-glance>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import ActivePacksAtAGlance from "../../components/ActivePacksAtAGlance.vue";

export default {
  components: { ActivePacksAtAGlance },
  computed: {
    filteredActivePackList() {
      const filteredPackList = this.packList.filter(pack => {
        // If a pack has the pilotParticipationList value set to an empty array or null, any member can see the pack in the pack list.
        // If Service Area ids are specified in the pilotParticipationList value, then only display if the logged in user's Service Area matches one in the list.
        if (
          !pack.pilotParticipationList ||
          pack.pilotParticipationList.length === 0 ||
          pack.pilotParticipationList.includes(this.loggedInUserServiceArea)
        ) {
          return pack;
        }
      });

      // Active packs should display with the oldest one at the top of the list.
      filteredPackList.sort((a, b) => (a.uatStart > b.uatStart ? 1 : -1));

      return filteredPackList;
    },
    releaseCyclePacks() {
      return this.getPackListByType(["Enhancement Pack", "Service Pack", "Fix Pack"]);
    },
    criticalFixPacks() {
      return this.getPackListByType(["Critical Fix"]);
    },
    projectStandalonePacks() {
      return this.getPackListByType(["Project", "Standalone"]);
    },
    ...mapGetters({
      packList: "pack/getActivePackList",
    }),
    ...mapState({
      isOchinUser: state => state.session.user.isOchinUser,
      loggedInUserServiceArea: state => state.session.user.serviceArea,
    }),
  },
  async created() {
    if (this.packList.length > 1) {
      return;
    }
    try {
      this.packDataIsLoading = true;
      await this.getPackList();
    } catch (error) {
      console.error(error);
      this.$notifyError({
        message: `Could not load pack list`,
      });
    }
    this.packDataIsLoading = false;
  },
  data() {
    return {
      packDataIsLoading: false,
    };
  },
  methods: {
    getPackListByType(packType) {
      const filteredPackList = this.packList.filter(pack => {
        if (packType.includes(pack.type)) {
          return pack;
        }
      });
      // Active packs should display with the oldest one at the top of the list.
      filteredPackList.sort((a, b) => (a.uatStart > b.uatStart ? 1 : -1));
      return filteredPackList;
    },
    ...mapActions({
      getPackList: "pack/getList",
    }),
  },
};
</script>

<style>
.widgetActivePackList__tabs {
  border-right: 1px solid #e6e6e6;
}

.widgetActivePackList__item {
  cursor: pointer;
}
</style>
